















































































































import Vue from 'vue';
import { mapGetters } from 'vuex';

import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';
import { formatMixin } from '@/mixins/format';

import localStorageService from '@/services/LocalStorageService';
import apiLogsService from '@/services/ApiLogsService';
import ApiLogsSearchRequest from '@/models/requests/ApiLogsSearchRequest';
import accountsService from '@/services/AccountsService';

import User from '@/models/User';
import DropdownOption from '@/models/misc/DropdownOption';

import ApiLogsGrid from './LogsGrid.vue';

export default Vue.extend<any, any, any, any>({
  components: {
    ApiLogsGrid,
  },
  mixins: [iconsMixin, breakpointsMixin, authMixin, formatMixin],
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      totalPages: 0,
      loading: false,
      snackbar: false,
      snackbarText: '',
      term: '',
      selectedLog: null,
      selectedDate: null,
      minAllowedDate: null,
      maxAllowedDate: null,
      selectedUser: null,
      usersDdl: [] as DropdownOption[],
      users: [] as User[],
    };
  },
  created() {
    this.selectedDate = this.formatDateForInput(new Date());
    this.minAllowedDate = this.formatDateForInput(this.getDateOneMonthAgo());
    this.maxAllowedDate = this.formatDateForInput(new Date());

    this.fetchUsers();
    this.fetch();
  },
  methods: {
    backToPrevPage() {
      history.back();
    },
    onClear() {
      this.term = '';
    },
    performSearch() {
      this.applyFilters();
    },
    fetch() {
      this.loading = true;

      const accountId = this.$route.params.accountId;
      if (!accountId) {
        console.error('Account ID not found in route parameters');
        this.loading = false;
        return;
      }

      const request: ApiLogsSearchRequest = {
        accountId: accountId,
        page: this.currentPage,
        pageSize: this.pageSize,
        searchTerm: this.term || undefined,
        filterDate: this.selectedDate || undefined,
        userId: this.selectedUser?.value || undefined,
      };

      apiLogsService
        .search(request)
        .then((response) => {
          // store the logs data in the store
          this.$store.commit('apiLogs/setLogs', response.logs);
          this.$store.commit('apiLogs/setPage', response.logs);

          // update pagination info
          this.totalCount = response.totalItems;
          this.totalPages = Math.ceil(this.totalCount / this.pageSize);

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.$toast.error('Error loading API logs. Please try again.');
        });
    },
    applyFilters() {
      // reset to first page when filters change
      this.currentPage = 1;

      // fetch new data with current filters
      this.fetch();
    },
    pageChange(newPage) {
      this.currentPage = newPage;
      this.fetch();
    },
    viewDetails(log) {
      if (!log) return;

      // make a copy of the log to avoid modifying the original
      this.selectedLog = { ...log };

      // if the message contains JSON data, try to parse it
      if (
        log.message &&
        (log.message.includes('Request |') ||
          log.message.includes('Response |'))
      ) {
        try {
          // extract JSON data from the message if it exists
          const parts = log.message.split(' | ');
          if (parts.length > 1) {
            const jsonStr = parts[1];
            const jsonData = JSON.parse(jsonStr);

            // set request or response based on the message type
            if (log.message.includes('Request |') && !log.request) {
              this.selectedLog.request = jsonData;
            } else if (log.message.includes('Response |') && !log.response) {
              this.selectedLog.response = jsonData;
            }
          }
        } catch (e) {
          console.error('Error parsing JSON from message:', e);
        }
      }
    },
    copyToClipboard(text) {
      // create a temporary textarea element
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);

      // select and copy the text
      textarea.select();
      document.execCommand('copy');

      // remove the temporary element
      document.body.removeChild(textarea);

      // show a snackbar notification
      this.snackbarText = 'Copied to clipboard!';
      this.snackbar = true;
    },
    formatDetailTimestamp(timestamp) {
      if (!timestamp) return 'N/A';

      // format timestamp as "YYYY-MM-DD HH:MM:SS" with additional formatting
      const date = new Date(timestamp);
      if (isNaN(date.getTime())) return 'N/A';

      // format date and time with full details
      return date.toLocaleString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      });
    },

    formatDateForInput(date) {
      if (!date) return null;
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    getDateOneMonthAgo() {
      const today = new Date();
      const oneMonthAgo = new Date(today);
      oneMonthAgo.setMonth(today.getMonth() - 1);
      return oneMonthAgo;
    },
    fetchUsers() {
      const accountId = this.$route.params.accountId;
      if (!accountId) {
        console.error('Account ID not found in route parameters');
        return;
      }

      accountsService
        .getUsers(accountId)
        .then((users: User[]) => {
          this.users = users;
          this.usersDdl = users.map(this.mapUser);
        })
        .catch((error) => {
          console.error('Error fetching users:', error);
        });
    },
    mapUser(user: User) {
      return new DropdownOption(
        user.firstName + ' ' + user.lastName,
        user.userId ?? ''
      );
    },
  },
  computed: {
    ...mapGetters('apiLogs', ['all', 'page', 'filteredLogs', 'searchFilter']),
    pageHeader() {
      return `${this.client?.company}'s API Integration Logs`;
    },
    client() {
      return localStorageService.get('selected-afs-client');
    },
    pagingLength() {
      return this.totalPages || 0;
    },
    backToLbl() {
      return document.referrer?.includes('/dashboard')
        ? 'Back to Dashboard'
        : 'Back to Clients';
    },
  },
});
